function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M143.151 132.76C106.555 132.674 76.843 102.833 76.9289 66.2226C77.0148 29.7121 106.784 0 143.309 0C180.063 0.0858732 209.775 29.9268 209.689 66.5374C209.603 103.048 179.834 132.76 143.309 132.76H143.151Z",
  fill: "#FFD417"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M98.168 66.3798C98.168 91.3117 118.377 111.521 143.309 111.521C162.444 111.521 178.789 99.6128 185.358 82.8102",
  stroke: "#111927",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M188.449 66.3798C188.449 41.4479 168.241 21.2391 143.309 21.2391C123.715 21.2391 107.027 33.7336 100.787 51.1802",
  stroke: "#111927",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M178.946 59.1804L188.45 68.6837L197.953 59.1804",
  stroke: "#111927",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M107.672 74.352L98.1683 64.8487L88.665 74.352",
  stroke: "#111927",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.24548 59.3189L39.5854 8.98597C41.1234 6.7267 44.3646 6.48759 46.2174 8.49672L87.5718 53.2455C88.9125 54.7008 89.0736 56.8848 87.961 58.5211L53.621 108.854C52.0831 111.113 48.8419 111.352 46.989 109.343L5.63468 64.5945C4.29397 63.1392 4.13285 60.9552 5.24548 59.3189Z",
  fill: "#111927"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M81.3139 56.3541L43.3817 15.3137L11.8826 61.4762L49.8156 102.527L81.3139 56.3541Z",
  stroke: "#F2F2EF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M43.3809 15.3137L49.8148 102.527",
  stroke: "#F2F2EF",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M47.6206 72.7776L11.8823 61.4763L45.576 45.0629L81.3136 56.3542L47.6206 72.7776Z",
  stroke: "#F2F2EF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M168.571 184.521C148.342 176.498 136.134 171.656 130.866 159.485C125.615 147.307 130.456 135.1 138.479 114.871C146.502 94.6418 151.344 82.4343 163.51 77.178C175.693 71.9147 187.901 76.7564 208.13 84.7794C228.359 92.8025 240.566 97.6442 245.834 109.815C251.086 121.993 246.244 134.201 238.221 154.43C230.198 174.659 225.356 186.866 213.185 192.134C201.007 197.386 188.8 192.544 168.571 184.521Z",
  fill: "#00C16B"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M170.889 178.675C190.183 186.327 200.905 190.579 210.687 186.353C220.469 182.127 224.722 171.404 232.374 152.111C240.026 132.817 244.279 122.095 240.053 112.313C235.826 102.531 225.104 98.278 205.81 90.626C186.517 82.9739 175.794 78.7212 166.012 82.9474C156.23 87.1736 151.978 97.8961 144.325 117.19C136.673 136.483 132.421 147.206 136.647 156.988C140.873 166.77 151.596 171.022 170.889 178.675V178.675Z",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M168.249 115.216L172.915 117.066L170.902 122.141L170.949 122.16L176.376 118.439L181.661 120.535L174.754 124.643L175.612 135.958L170.362 133.876L170.124 126.934L168.56 127.978L166.788 132.445L162.123 130.595L168.23 115.195L168.249 115.216Z",
  fill: "#111927"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M182.608 120.911L187.274 122.761L181.166 138.161L176.501 136.31L182.608 120.911Z",
  fill: "#111927"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M188.162 123.113L192.874 124.982L190.462 136.218L190.508 136.237L196.756 126.522L202.217 128.688L200.12 140.049L200.167 140.067L206.088 130.223L210.8 132.092L201.126 146.077L195.455 143.828L197.536 132.609L197.489 132.591L191.315 142.186L185.644 139.937L188.185 123.123L188.162 123.113Z",
  fill: "#111927"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M211.642 132.426L216.307 134.276L210.199 149.676L205.534 147.825L211.642 132.426Z",
  fill: "#111927"
});

function SvgEthReloadKiwi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 205,
    viewBox: "0 0 258 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthReloadKiwi);
export default __webpack_public_path__ + "static/media/eth-reload-kiwi.aed69907.svg";
export { ForwardRef as ReactComponent };